import { render, staticRenderFns } from "./ModuleIndex.vue?vue&type=template&id=282af467&scoped=true&"
import script from "./ModuleIndex.vue?vue&type=script&lang=js&"
export * from "./ModuleIndex.vue?vue&type=script&lang=js&"
import style0 from "./ModuleIndex.vue?vue&type=style&index=0&id=282af467&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282af467",
  null
  
)

export default component.exports